export const spellOutForScreenReader = (value?: string | number | null): string =>
  value === null || value === undefined ? "" : String(value).split("").join(" ")
